import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "ProtocolHomeTileContainer": () => import("./components/ProtocolHomeTileContainer.vue"),
    "ProtocolSingleTileContainer": () => import("./components/ProtocolSingleTileContainer.vue"),

    "ActivityGenericCreatorTile": () => import("./components/tiles/activities/ActivityGenericCreatorTile.vue"),
    "SaveProtocolActivityStep": () => import("./components/steps/SaveProtocolActivityStep.vue"),
    "ProtocolFormDataStep": () => import("./components/steps/ProtocolFormDataStep.vue"),
    "ProtocolFormDataSummary": () => import("./components/summaries/ProtocolFormDataSummary.vue"),

    "ProtocolStepperContainer": () => import("./components/tiles/ProtocolStepperContainer.vue"),
    "ProtocolListTile": () => import("./components/tiles/protocol/ProtocolListTile.vue"),
    "ProtocolCreateEditTile": () => import("./components/tiles/protocol/ProtocolCreateEditTile.vue"),
    "ProtocolListStatusTile": () => import("./components/tiles/protocol/ProtocolListStatusTile.vue"),
    "ApplyAgronomicProtocolStepper": () => import("./components/tiles/protocol/ApplyAgronomicProtocolStepper.vue"),
    "RemoveProtocolPlots": () => import("./components/tiles/protocol/RemoveProtocolPlots.vue"),
    "PlotsToRemoveTableComponent": () => import("./components/tiles/protocol/PlotsToRemoveTableComponent.vue"),

    "ProtocolActivityContainer": () => import("./components/ProtocolActivityContainer.vue"),
    "ProtocolActivitiesList": () => import("./components/tiles/activities/ProtocolActivitiesList.vue"),
    "ProtocolActivityDetailTile": () => import("./components/tiles/activities/ProtocolActivityDetailTile.vue"),
    "ProtocolAddActivitySummaryTile": () => import("./components/tiles/activities/ProtocolAddActivitySummaryTile.vue"),
    "ProtocolAddActivityStepperTile": () => import("./components/tiles/activities/ProtocolAddActivityStepperTile.vue"),
    "ProtocolEditActivitySummaryTile": () => import("./components/tiles/activities/ProtocolEditActivitySummaryTile.vue"),
    "ProtocolEditActivityStepperTile": () => import("./components/tiles/activities/ProtocolEditActivityStepperTile.vue"),

    "ProtocolPrescriptionsList": () => import("./components/tiles/prescriptions/ProtocolPrescriptionsList.vue"),

    "ProtocolVarietiesList": () => import("./components/tiles/varieties/ProtocolVarietiesList.vue"),
    "ProtocolVarietiesModalAdd": () => import("./components/tiles/varieties/ProtocolVarietiesModalAdd.vue"),

    "ProtocolFertilizerPlanDetail": () => import("./components/tiles/fertilizerPlan/ProtocolFertilizerPlanDetail.vue"),
    "ProtocolFertilizerPlanList": () => import("./components/tiles/fertilizerPlan/ProtocolFertilizerPlanList.vue")

};

export default globals;
